export default "__VITE_ASSET__CQPah4gN__"